var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplitBalancesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.646484,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F7E5FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5880_34436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 18.6465H24.5V20.6465H26.5V26.6465H14.5V20.6465H15.5V18.6465H13.5C12.9 18.6465 12.5 19.0465 12.5 19.6465V27.6465C12.5 28.2465 12.9 28.6465 13.5 28.6465H27.5C28.1 28.6465 28.5 28.2465 28.5 27.6465V19.6465C28.5 19.0465 28.1 18.6465 27.5 18.6465Z",
    fill: "#D77EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.6465H19.5C19.8 20.6465 20 20.5465 20.2 20.3465L25.2 15.3465C25.6 14.9465 25.6 14.3465 25.2 13.9465L24.2 12.9465C23.8 12.5465 23.2 12.5465 22.8 12.9465L17.8 17.9465C17.6 18.1465 17.5 18.3465 17.5 18.6465V20.6465Z",
    fill: "#D77EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 22.6465H16.5V24.6465H24.5V22.6465Z",
    fill: "#D77EF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5880_34436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12.5 12.6465)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitBalancesIcon);
export default __webpack_public_path__ + "static/media/split-balances-icon.622a9cd374727403742f2c349fdaca60.svg";
export { ForwardRef as ReactComponent };